import { compact, path } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const downloadLink = ({ primary }) =>
  compact({
    type: CommonSliceType.DOWNLOAD_LINK,
    label: toTextFromProp('label', primary),
    url: path('link.url', primary),
    weight: path('link.size', primary),
    linkType: 'download',
  });
